export default __webpack_public_path__ + "static/media/cc_blue.cb285ff3.jpg";